import type {LocaleCode} from '@helios/shared/locale/locales'

import type {State} from './cashback-calculator'
import {generateLocaleData} from './shared'

const NUM_OF_FREE_USERS = 3

export const calculateCashback = (
    {monthlySpend, numOfEmployees}: State,
    localeCode: LocaleCode
) => {
    const advancedPlanCost = generateLocaleData(localeCode).cost
    let paidUsers = numOfEmployees - NUM_OF_FREE_USERS
    let additionalUserCost = 0
    const earnedCashback = monthlySpend / 100

    if (paidUsers > 0) {
        for (let i = 1; i < paidUsers + 1; i++) {
            additionalUserCost += getAdditionalUserCostByCountry(localeCode, i)
        }
    }

    const cap = advancedPlanCost + additionalUserCost

    return (earnedCashback < cap ? earnedCashback : cap) * 12
}

const getAdditionalUserCostDkk = (userQty: number) => {
    if (userQty <= 10) {
        return 125
    }
    if (userQty <= 30) {
        return 115
    }
    if (userQty <= 50) {
        return 110
    }
    if (userQty <= 100) {
        return 100
    }
    if (userQty <= 200) {
        return 90
    }
    if (userQty <= 400) {
        return 80
    }
    if (userQty <= 600) {
        return 70
    }
    return 65
}

const getAdditionalUserCostEurGbp = (userQty: number) => {
    if (userQty <= 10) {
        return 14
    }
    if (userQty <= 30) {
        return 13
    }
    if (userQty <= 50) {
        return 12
    }
    if (userQty <= 100) {
        return 11
    }
    if (userQty <= 200) {
        return 10
    }
    if (userQty <= 400) {
        return 9
    }
    if (userQty <= 600) {
        return 8
    }
    return 7
}

const getAdditionalUserCostSek = (userQty: number) => {
    if (userQty <= 10) {
        return 170
    }
    if (userQty <= 30) {
        return 155
    }
    if (userQty <= 50) {
        return 145
    }
    if (userQty <= 100) {
        return 130
    }
    if (userQty <= 200) {
        return 120
    }
    if (userQty <= 400) {
        return 110
    }
    if (userQty <= 600) {
        return 95
    }
    return 85
}

const getAdditionalUserCostByCountry = (localeCode: LocaleCode, userQty: number) => {
    switch (localeCode) {
        case 'da-dk':
            return getAdditionalUserCostDkk(userQty)
        case 'sv-se':
            return getAdditionalUserCostSek(userQty)
        default:
            return getAdditionalUserCostEurGbp(userQty)
    }
}
